import axios from 'axios'
import AuthService from '@/services/auth_service'
import NotifyService from '@/services/notify_service'
import router from '@/router';
import { AppModule } from '@/store/modules/app';
import ShareService from "@/services/share-service";

const authService = AuthService;
const notify = NotifyService;

let service = axios.create({
// @ts-ignore
  baseURL: config.VUE_APP_BASE_API, // global var from config
  timeout: 60000*15  // увеличен до 15 min
  // withCredentials: true // send cookies when cross-domain requests
});

// Request interceptors
service.interceptors.request.use(
  (config) => {

    const token = authService.getToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
)

service.interceptors.request.use( config => {
  // Не выполнять запросы к серверу пока выполняется сквозной вход через Active Directory
  if (AppModule.fetchActiveDirectoryLogin && !['/auth/login', '/auth/validate'].includes(config.url || '')) {
    return { ...config, cancelToken: new axios.CancelToken((cancel) => cancel('Cancel repeated request')) }
  }
  return config;

})

// Response interceptors
service.interceptors.response.use(
  async(response) => {
    // Если это blob-ответ, верните полный response объект
    if (response.config.responseType === 'blob') {
      return response
    }
    return response.data
  },
  async(error) => {

    // @ts-ignore
    const isAdAuth = !!config.VUE_APP_AD_AUTH; // Флаг входа через active Directory

    if (error.response && error.response.status === 401) {
      // Если пришло уведомление о неавторизованном входе
      if (!notify.isHandling401) {
        if (router.currentRoute.path === '/login') {
          if (error.response.config.url === '/auth/login') {
            // Для ошибки запроса входа в систему отображать текст ошибки, полученный с серевера
            notify.error(error.response.data?.message || error.response.data?.detail, true)
          } else {
            if (!isAdAuth) {
            }
          }
        } else if (router.currentRoute.path === '/init_admin') {
          if (error.response.config.url === '/auth/init_admin') {
            notify.error(error.response.data.detail, true);
          }
        } else if (error.response.config.url === '/auth/login') {
          // Для ошибки запроса входа в систему отображать текст ошибки, полученный с серевера
          let message = error.response.data?.message || error.response.data?.detail;
          if (isAdAuth) {
            notify.error(message || 'Вход в систеу не был выполнен', true, 10000)
          }  else {
            notify.error(message, true);
            await router.replace(`/login`);
          }

        } else {
          // Обработка всех ответов на 401 ошибку для страниц, не являющиеся login и init_admin
          if (isAdAuth) {
            if (AuthService.getToken() && !AppModule.fetchActiveDirectoryLogin) {


              AuthService.resetToken();
              AppModule.SetAdLogin(true)
              AuthService.login({ login: 'login'}, 1100000).then((resp: any) => {
                AppModule.SetAdLogin(false)
                if (resp.data) {
                  AuthService.saveUserToken(resp.data);
                  notify.isHandling401 = false;
                  // ToDo: Возмможнно подгрузка кэшей при обработке 401 ошибки не требуется

                }
              });
            }

          } else {
            notify.isHandling401 = true;
            await authService.logout();
            await router.replace(`/login`);
          }
        }
      }
      return Promise.reject(new Error('Ошибка проверки ключа доступа'))

    }  else if (error.response && (error.response.status === 409 || error.response.status === 500)) {
      notify.error(error.response.data.message || error.response.data.detail);
      return Promise.reject(new Error(error.response.data.message || error.response.data.detail))

    }
    else if (error.response && error.response.status === 403) {

      notify.error('Недостаточно прав для выполенния операции. Обратитесь к администратору', true);
      return Promise.reject(new Error('Ошибка проверки прав доступа'))

    }  else if (error.response && error.response.status === 400 && error.response.data && error.response.data.schema_errors) {


      let s = 'Ошибка валидации схемы данных: ';
      for (let k in error.response.data.schema_errors) {
        s += `${k}: ${error.response.data.schema_errors[k][0]}; `;
      }

      notify.error(s)
      return Promise.reject(new Error(s))

    } else if (error.response && error.response.status === 400 && error.response.data.message) {

      notify.error(error.response.data.message);
      return Promise.reject(new Error(error.response.data.message))
    } else if ((error.response && error.response.status === 502) || (error.message && error.message.toLowerCase() === 'network error')) {
      AppModule.SetConnectionState(false)
    }

    return Promise.reject(error)
  }
)

export default service
